import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "text-white" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_icon = _resolveComponent("q-icon");
    const _component_q_space = _resolveComponent("q-space");
    const _component_q_tooltip = _resolveComponent("q-tooltip");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_bar = _resolveComponent("q-bar");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_dialog = _resolveComponent("q-dialog");
    const _directive_close_popup = _resolveDirective("close-popup");
    return (_openBlock(), _createBlock(_component_q_dialog, {
        modelValue: _ctx.show,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.show) = $event)),
        onHide: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('close')))
    }, {
        default: _withCtx(() => [
            _createVNode(_component_q_card, { style: { "min-width": "350px" } }, {
                default: _withCtx(() => [
                    _createVNode(_component_q_bar, { class: "bg-primary text-white" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_q_icon, { name: "fa-solid fa-comments" }),
                            _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('Description')), 1),
                            _createVNode(_component_q_space),
                            _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                                icon: "close",
                                dense: "",
                                flat: ""
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_q_tooltip, null, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('Close')), 1)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            })), [
                                [_directive_close_popup]
                            ])
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_q_card_section, null, {
                        default: _withCtx(() => [
                            _createElementVNode("p", null, _toDisplayString(_ctx.description), 1)
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            })
        ]),
        _: 1
    }, 8, ["modelValue"]));
}
